<template>
  <div class="mb-select">
    <div class="PageOverlay" @click.stop="send_onoff" :class="{ showPageOverlay: onOff }"></div>
    <div class="select-content" :class="{ showSelectContent: onOff }" v-show="onOff">
      <div class="mb-close text-center" @click.stop="send_onoff">
        <button>
          <svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">
            <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd" />
          </svg>
        </button>
        {{item.name}}
      </div>
      <ul class="select-content-list pop-rhombus">
        <li
          v-for="subitem in item.value.slice(0,type=='detail'?item.value.length:palette_config.show_num)"
          :key="subitem"
          @click="send(subitem)"
          class="text-center"
          :class="{'active':value==subitem}"
        >
          <v-typelist layout="right" :palette_config="palette_config" :item="item" :value="subitem"></v-typelist>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import vTypelist from "./typelist";
export default {
  props: ["item", "palette_config", "onOff", "index", "type", "value"],
  methods: {
    reg(e) {
      return e.replace(/[^a-zA-Z0-9]/g, "");
    },
    send(val) {
      let obj = {
        index: this.index,
        val
      };
      this.bus.$emit("get_variant", obj);
      this.bus.$emit("get_onoff", !this.onOff);
    },
    send_onoff() {
      this.bus.$emit("get_onoff", false);
    }
  },
  mounted() {
    console.log(this.item, "itemitemitem");
  },
  components: {
    vTypelist
  }
};
</script>

<style  scoped lang='scss'>
.mb-select {
  .select-content {
    position: absolute;
    box-shadow: 0 -2px 10px rgb(54 54 54 / 20%);
    background-color: white;
    line-height: 1.65;
    z-index: 1025;
    right: 0;
    top: 76px;
    .mb-close {
      display: none;
      padding: 13px 20px;
      position: relative;
      font-size: 15px;
      font-family: "Muli-Bold";
      border-bottom: 1px solid rgba(227, 227, 227, 0.4);

      button {
        width: 38px;
        height: 30px;
        position: absolute;
        left: 7px;
        top: 6px;
        background: transparent;
        border: none;
      }
      svg {
        display: inline-block;
        width: 14px;
        fill: currentColor;
        vertical-align: middle;
        stroke-width: 1px;
        background: 0 0;
        pointer-events: none;
      }
    }
    .select-content-list {
      padding: 18px 0;
      &::after {
        left: unset;
        top: -8px;
        right: 32px;
      }
      li {
        color: #666;
        list-style: none;
        letter-spacing: 1px;
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        display: block;
        // padding: 0px 20px;
        // white-space: nowrap;
        cursor: pointer;
        user-select: none;
        transition: color 0.2s ease-in-out;
        // padding-left: 50px;
        // padding-right: 50px;
        text-align: right;
        font-family: Muli;
        text-transform: uppercase;
         &::v-deep .palette-select-list {
          display: flex;
          align-items: center;
          flex-direction: row-reverse;
          .nowarp {
            line-height: 1.5rem;
            padding: 5px 10px;
            max-width: 100%;
            overflow: unset;
            display: block;
            white-space: unset;
            flex: 1;
          }
      }
      }
      & > .active {
        background-color: rgba(245, 165, 3, 0.1);
        font-weight: bold;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .showPageOverlay {
    opacity: 0.5;
    visibility: visible;
  }
  .mb-select {
    .select-content {
      display: block !important;
      visibility: hidden;
      position: fixed;
      top: unset;
      bottom: 0;
      width: 100%;
      touch-action: manipulation;
      -webkit-transform: translateY(100%);
      transform: translateY(100%);
      -webkit-transition: all 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: all 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
      .mb-close {
        display: block;
      }
      .select-content-list {
        &::after {
          display: none;
        }
        li {
          text-align: center;
        }
      }
    }
    .showSelectContent {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      visibility: visible;
    }
  }
}
</style>